import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { usd, signed, tone, TONE } from "./utils";

const Pct = ({ v }) => (
  <span className={`font-num ${tone(v) === "up" ? "text-[#34D399]" : tone(v) === "down" ? "text-[#F87171]" : "text-slate-400"}`}>{signed(v, 3)}%</span>
);

export const ReadingsLog = ({ readings, onClear }) => (
  <section className="card p-5 sm:p-6 fade-up" data-testid="readings-log">
    <div className="flex items-end justify-between gap-2">
      <div>
        <h2 className="font-head font-bold text-lg">Readings log</h2>
        <p className="text-xs text-slate-400 mt-1">A snapshot is saved every 60 seconds so you can see how things changed.</p>
      </div>
      <button onClick={onClear} className="text-xs text-slate-500 hover:text-red-400" data-testid="clear-log-btn">Clear log</button>
    </div>
    <div className="mt-4 overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="border-[#1A2338] hover:bg-transparent">
            {["Time", "Price", "1m", "5m", "15m", "Momentum"].map((h) => (
              <TableHead key={h} className="text-[10px] uppercase tracking-widest font-num text-slate-500 whitespace-nowrap">{h}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {readings.map((r) => (
            <TableRow key={r.id} className="border-[#1A2338] hover:bg-[#111A2C] text-xs" data-testid="reading-row">
              <TableCell className="font-num whitespace-nowrap text-slate-400">{new Date(r.timestamp).toLocaleTimeString()}</TableCell>
              <TableCell className="font-num whitespace-nowrap">{usd(r.price)}</TableCell>
              <TableCell><Pct v={r.pct_1m} /></TableCell>
              <TableCell><Pct v={r.pct_5m} /></TableCell>
              <TableCell><Pct v={r.pct_15m} /></TableCell>
              <TableCell><span className={`px-2 py-0.5 rounded-full border text-[10px] font-bold ${TONE[r.momentum]}`}>{r.momentum}</span></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {!readings.length && <p className="text-sm text-slate-500 py-6 text-center" data-testid="readings-empty">No readings yet — the first one is saved on load.</p>}
    </div>
  </section>
);
